import { useEffect, useState } from 'react';
import { PartesDaAba } from '../../components/PartesDaAba';
import { temPartes } from '../../lib/partes';
import { MODOS_CAIXINHA, modoDaCaixinha, mudarModoCaixinha, type ModoCaixinha } from '../../components/Caixinhas';
import { Modal, Platform, Pressable, ScrollView, Text, View } from 'react-native';
import { proximosAlertas, totalAgendados } from '../../notifications';
import { useRouter } from 'expo-router';
import { MOD_IDS, type AbaId, type ModId, type ModoAviso, type Shape } from '../../store/types';
import { setDoc, useDoc } from '../../store/store';
import { metaAgua } from '../../store/bemestar';
import { Field, Section, Sheet, Swatches } from '../../components/ui';
import { setMei } from '../../store/financas';
import { lerValor } from '../../lib/moeda';
import { ABAS, abasVisiveis, C, aba, alpha, useCores } from '../../components/theme';
import { CATEGORIAS_ICONES, DoneMark, TimerShape } from '../../components/Shapes';
import { N_, t, useIdioma } from '../../lib/i18n';
import { DIAS_TESTE_ABA } from '../../lib/plano';
import Paywall from '../Paywall';
import { horaTela, hm, norm } from '../../lib/date';
import { durLabel } from '../../lib/time';
import { MODOS_AVISO, avisoDoApp, modoVibra, sentirModo } from '../../lib/avisos';
import { ListaComSentir } from './Avisos';
import { BotaoAcao, Bloco, Dica, Divisor, LinhaChave, LinhaEscolha, LinhaOpcoes } from '../../components/ajustes/Linhas';
import { BotaoMenu, Card, Contador, Expansivel, Linha } from './comum';
import { LimparAgenda } from './LimparAgenda';
import { ConfigDiario } from '../../components/diario/ConfigDiario';
import { useConfirmarIdentidade } from '../../components/ConfirmarIdentidade';
import { ABAS_SEM_TRAVA, mudarSenhaAba, type RegraSenhaAba } from '../../lib/travaAba';
import { PaginasDaAba } from '../../components/ConfigPaginas';
import { AlvoGuia } from '../../components/guia/Destaque';
import { temComoUsar } from '../../components/ComoUsarAba';
import { ABAS_COM_PAGINAS } from '../../lib/paginas';
import { EMOJIS_PAUSA } from '../../lib/pausas';

const SEMANA = [N_('Domingo'), N_('Segunda'), N_('Terça'), N_('Quarta'), N_('Quinta'), N_('Sexta'), N_('Sábado')];
const HORAS_RESUMO = ['05:30', '06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00'];
const DURACOES = [5, 10, 15, 30, 45, 60, 90, 120];
/** Opções de som/vibração com "Padrão do app" em primeiro (sem escolha = padrão). */
const opcoesAviso = (): [ModoAviso | 'app', string][] => [['app', t('Padrão do app')], ...MODOS_AVISO.map(([k, l]) => [k, t(l)] as [ModoAviso, string])];

/** Ajustes > Abas (0.67, texto 05 D4): busca no topo e dois blocos, "Ligadas" e "Desligadas". Cada uma abre as próprias configurações.
 *  0.67.2 (texto 07 C5): My Planner sempre no topo e as demais em ordem alfabética (pelo nome no idioma do app) dentro de cada bloco.
 *  As abas sem acesso aparecem com 🔒 e "Teste grátis por 10 dias"; tocar abre a explicação da aba com testar/assinar (a mesma tela de aba
 *  bloqueada, screens/Paywall), sem abrir as configurações da aba. */
export function ListaAbas({ onAbrir, onCompras }: { onAbrir: (id: AbaId) => void; onCompras: () => void }) {
  const { corDe, liberada, situacao } = useCores();
  const lang = useIdioma();
  const [busca, setBusca] = useState('');
  const [explicar, setExplicar] = useState<AbaId | null>(null);
  const q = norm(busca.trim());
  const achou = (x: (typeof ABAS)[number]) => !q || norm(x.nome).includes(q) || norm(x.desc).includes(q);
  let col: Intl.Collator | null = null;
  try { col = new Intl.Collator(lang); } catch { /* sem Intl.Collator */ }
  const ordem = (a: (typeof ABAS)[number], b: (typeof ABAS)[number]) =>
    a.id === 'planner' ? -1 : b.id === 'planner' ? 1 : col ? col.compare(a.nome, b.nome) : norm(a.nome).localeCompare(norm(b.nome));
  const ligadas = abasVisiveis().filter(x => liberada(x.id) && achou(x)).sort(ordem);
  const desligadas = abasVisiveis().filter(x => !liberada(x.id) && achou(x)).sort(ordem);
  // começou o teste ou assinou na explicação: a aba passa para "Ligadas" e a explicação fecha
  useEffect(() => { if (explicar && liberada(explicar)) setExplicar(null); });
  const bola = (id: AbaId) => <View style={{ width: 14, height: 14, borderRadius: 7, backgroundColor: corDe(id) }} />;
  const resumoBloqueada = (id: AbaId) => (situacao(id).tipo === 'vencida' ? t('O teste grátis terminou') : t('Teste grátis por {n} dias', { n: DIAS_TESTE_ABA }));
  return (<>
    <Field value={busca} onChangeText={setBusca} placeholder={'🔍 ' + t('Buscar abas')} autoCorrect={false} semDitado />
    {ligadas.length > 0 && <Section t={t('Ligadas')} />}
    {ligadas.map(x => (
      <BotaoMenu key={x.id} icon={x.icon} titulo={x.nome} resumo={x.desc} onPress={() => onAbrir(x.id)} direita={bola(x.id)} />
    ))}
    {desligadas.length > 0 && (<>
      <Section t={t('Desligadas')} />
      {desligadas.map(x => <BotaoMenu key={x.id} icon={x.icon} titulo={x.nome} resumo={resumoBloqueada(x.id)} onPress={() => setExplicar(x.id)}
        direita={<View style={{ flexDirection: 'row', alignItems: 'center', gap: 6 }}><Text>🔒</Text>{bola(x.id)}</View>} />)}
      <BotaoAcao cor={corDe('planner')} label={'🛒 ' + t('Ver em Compras')} onPress={onCompras} />
    </>)}
    {!ligadas.length && !desligadas.length && <Text style={{ color: C.sub, textAlign: 'center', marginTop: 12 }}>{t('Nenhuma aba encontrada.')}</Text>}
    <Modal visible={!!explicar} animationType="slide" presentationStyle="fullScreen" onRequestClose={() => setExplicar(null)}>
      {!!explicar && <Paywall id={explicar} onBack={() => setExplicar(null)} />}
    </Modal>
  </>);
}

/** Som e vibração só desta aba (0.67, texto 05 G1). Sem escolha = padrão do app (Ajustes > Avisos e alarmes). */
function SomDaAba({ id }: { id: AbaId }) {
  const aj = useDoc('ajustes');
  const { corDe } = useCores();
  const valor = aj.avisosAba?.[id] ?? 'app';
  const real = (v: ModoAviso | 'app'): ModoAviso => (v === 'app' ? avisoDoApp() : v);
  // 0.69 (texto 07 C1): recolhida, mostra a escolha atual; aberta, cada opção tem ▶ Sentir
  return (
    <Expansivel titulo={'🔔 ' + t('Som e vibração')} resumo={opcoesAviso().find(o => o[0] === valor)?.[1]}>
      <ListaComSentir cor={corDe(id)} valor={valor} opcoes={opcoesAviso()}
        podeSentir={v => modoVibra(real(v))} onSentir={v => sentirModo(real(v))}
        onEscolher={v => setDoc('ajustes', d => {
          const m = { ...d.avisosAba };
          if (v === 'app') delete m[id]; else m[id] = v;
          return { ...d, avisosAba: m };
        })} />
    </Expansivel>
  );
}

/** Nome do formato guardado ("Círculo", "Coração"...), para a linha de Formatos. */
function nomeForma(id: Shape | undefined) {
  for (const cat of CATEGORIAS_ICONES) { const f = cat.itens.find(x => x.id === id); if (f) return t(f.n); }
  return '';
}

/** Folha com a grade dos formatos (0.67, texto 05 D2): ✓ no atual; tocar escolhe e volta. */
function EscolherForma({ qual, cor, onClose }: { qual: 'concluir' | 'timer' | null; cor: string; onClose: () => void }) {
  const aj = useDoc('ajustes');
  const atual = qual === 'timer' ? aj.timer : aj.concluir;
  return (
    <Sheet visible={!!qual} onClose={onClose} title={qual === 'timer' ? t('Temporizador (direita)') : t('Concluir (esquerda)')}>
      <ScrollView contentContainerStyle={{ padding: 16, gap: 6, paddingBottom: 60 }}>
        {!!qual && CATEGORIAS_ICONES.map(cat => {
          const itens = cat.itens.filter(f => qual === 'timer' || f.id !== 'hexagono');
          const tem = itens.some(f => f.id === atual);
          return (
            <Expansivel key={cat.titulo + qual} titulo={t(cat.titulo)} resumo={tem ? '✓' : String(itens.length)} inicial={tem}>
              <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 10 }}>
                {itens.map(f => {
                  const sel = atual === f.id;
                  return (
                    <Pressable key={f.id + f.n} onPress={() => { setDoc('ajustes', d => ({ ...d, [qual]: f.id as Shape })); onClose(); }}
                      accessibilityRole="button" accessibilityState={{ selected: sel }} accessibilityLabel={t(f.n)}
                      style={{ width: 72, alignItems: 'center', gap: 4, padding: 8, borderRadius: 14, backgroundColor: sel ? alpha(cor, 0.2) : C.card2, borderWidth: 1, borderColor: sel ? cor : 'transparent' }}>
                      {qual === 'timer' ? <TimerShape shape={f.id} pct={0.55} color={cor} size={40} icon="📚" /> : <DoneMark shape={f.id} done={sel} color={cor} size={32} />}
                      <Text style={{ color: sel ? C.text : C.sub, fontSize: 10, textAlign: 'center', fontWeight: sel ? '700' : '400' }} numberOfLines={1}>{sel ? '✓ ' : ''}{t(f.n)}</Text>
                    </Pressable>
                  );
                })}
              </View>
            </Expansivel>
          );
        })}
      </ScrollView>
    </Sheet>
  );
}

function OpcoesPlanner({ cor, onAvisos }: { cor: string; onAvisos: () => void }) {
  const aj = useDoc('ajustes');
  const set = (fn: (d: typeof aj) => typeof aj) => setDoc('ajustes', fn);
  const e = aj.energia;
  const [formaDe, setFormaDe] = useState<'concluir' | 'timer' | null>(null);
  const pz = aj.pausas ?? {};
  const contador = (l: string, v: number, on: (n: number) => void, k?: number) => (
    <View key={k}><Divisor /><View style={{ paddingVertical: 8 }}><Linha l={l}><Contador cor={cor} v={v} on={on} /></Linha></View></View>
  );
  return (<>
    <Bloco titulo={t('Limite de energia por dia')}>
      <LinhaOpcoes icone="⚡" titulo={t('Limite de energia')} valor={e.modo}
        opcoes={[['sem', t('Sem limite')], ['todos', t('Todos os dias')], ['dias', t('Cada dia da semana')]]}
        onEscolher={m => set(d => ({ ...d, energia: { ...d.energia, modo: m } }))} />
      {e.modo === 'todos' && contador('⚡ ' + t('Limite diário'), e.todos, n => set(d => ({ ...d, energia: { ...e, todos: n } })))}
      {e.modo === 'dias' && [1, 2, 3, 4, 5, 6, 0].map(i => contador(t(SEMANA[i]), e.dias[i], n => set(d => ({ ...d, energia: { ...e, dias: e.dias.map((x, j) => (j === i ? n : x)) } })), i))}
      <Dica>{t('O total aparece no topo do My Planner. Se passar do limite, o raio fica vermelho. Tarefas "Relaxar" valem 0.')}</Dica>
    </Bloco>

    <Bloco titulo={t('Formatos')}>
      <LinhaEscolha icone="✔️" titulo={t('Concluir (esquerda)')} valor={nomeForma(aj.concluir)} onPress={() => setFormaDe('concluir')} />
      <Divisor />
      <LinhaEscolha icone="⏳" titulo={t('Temporizador (direita)')} valor={nomeForma(aj.timer)} onPress={() => setFormaDe('timer')} />
      <Dica>{t('O temporizador se enche de cor conforme o tempo da tarefa passa. Tocar nele abre o vínculo da tarefa.')}</Dica>
    </Bloco>
    <EscolherForma qual={formaDe} cor={cor} onClose={() => setFormaDe(null)} />

    <Bloco titulo={t('Pausas')}>
      <LinhaOpcoes icone="🔔" titulo={t('Alarme ou vibração das pausas')} valor={pz.aviso ?? 'app'} opcoes={opcoesAviso()}
        onEscolher={v => set(d => ({ ...d, pausas: { ...d.pausas, aviso: v === 'app' ? undefined : v } }))} />
      <Divisor />
      <LinhaOpcoes icone={pz.emoji ?? '☕'} titulo={t('Emoji da pausa')} valor={pz.emoji ?? '☕'}
        opcoes={EMOJIS_PAUSA.map(x => [x, x === '☕' ? `☕  (${t('padrão')})` : x] as [string, string])}
        onEscolher={v => set(d => ({ ...d, pausas: { ...d.pausas, emoji: v } }))} />
      <Dica>{t('Valem para as tarefas com pausas. Cada tarefa pode mudar o alarme e o emoji na própria ficha.')}</Dica>
    </Bloco>

    <Bloco titulo={t('Tarefa nova')}>
      <LinhaOpcoes icone="⏱️" titulo={t('Duração padrão de uma tarefa nova')} valor={aj.duracaoPadrao ?? 30}
        opcoes={DURACOES.map(m => [m, durLabel(m)] as [number, string])} onEscolher={m => set(d => ({ ...d, duracaoPadrao: m }))} />
    </Bloco>

    <Bloco titulo={t('Resumo da manhã')}>
      <LinhaChave icone="☀️" titulo={t('Aviso com as tarefas do dia')} cor={cor} valor={aj.resumo.ativo} onMudar={v => set(d => ({ ...d, resumo: { ...d.resumo, ativo: v } }))} />
      {aj.resumo.ativo && (<><Divisor />
        <LinhaOpcoes icone="⏰" titulo={t('Horário')} valor={aj.resumo.hora} opcoes={HORAS_RESUMO.map(h => [h, horaTela(h)] as [string, string])}
          onEscolher={h => set(d => ({ ...d, resumo: { ...d.resumo, hora: h } }))} />
      </>)}
      <Dica>{t('Todo dia no horário escolhido: quantas tarefas o dia tem, a primeira e a energia total.')}</Dica>
    </Bloco>

    <AlertasDoPlanner onAvisos={onAvisos} />

    <Bloco titulo={t('Feriados')}>
      <LinhaChave icone="🎉" titulo={t('Mostrar feriados no topo')} cor={cor} valor={aj.feriadosTopo !== false}
        onMudar={v => set(d => ({ ...d, feriadosTopo: v }))}
        dica={t('O botão 🎉 Feriados no topo do My Planner. O país e a lista de feriados ficam em Ajustes > Feriados.')} />
    </Bloco>

    <LimparAgenda cor={cor} />
  </>);
}

function OpcoesBemEstar({ cor }: { cor: string }) {
  const d = useDoc('bemestar');
  return (<>
    <Section t={t('Água')} />
    <Card>
      <Linha l={'💧 ' + t('Meta de copos por dia')}><Contador cor={cor} min={1} v={d.metaAgua} on={metaAgua} /></Linha>
    </Card>
  </>);
}

function OpcoesFinancas({ cor }: { cor: string }) {
  const d = useDoc('financas');
  const [lim, setLim] = useState(String(d.mei.limite));
  return (<>
    <Section t={t('MEI')} />
    <Card>
      <Text style={{ color: C.sub, fontSize: 12 }}>{t('Limite de faturamento anual do MEI (confira o valor vigente com o seu contador).')}</Text>
      <View style={{ flexDirection: 'row', gap: 8, alignItems: 'center' }}>
        <Field value={lim} onChangeText={setLim} keyboardType="decimal-pad" style={{ flex: 1 }} />
        <BotaoAcao cor={cor} label={t('Salvar')} onPress={() => { const v = lerValor(lim); if (v > 0) setMei(m => ({ ...m, limite: v })); }} />
      </View>
      <Linha l={t('Dia de vencimento do DAS')}><Contador cor={cor} min={1} v={d.mei.dasDia} on={n => setMei(m => ({ ...m, dasDia: Math.min(28, n) }))} /></Linha>
    </Card>
  </>);
}

/** Configurações de uma aba: cor do tema e as opções próprias dela (0.67: só o que é desta aba; o geral fica na capa de Ajustes). */
export function ConfigAba({ id, onCompras, onAvisos, onGuia }: { id: AbaId; onCompras: () => void; onAvisos: () => void;
  /** texto 28 (B6): abre o passo a passo da aba (página do Guia) */ onGuia?: () => void }) {
  const router = useRouter();
  const aj = useDoc('ajustes');
  const { corDe, liberada } = useCores();
  const a = aba(id);
  const cor = corDe(id);
  const ok = liberada(id);
  const abrir = () => id === 'planner' ? router.navigate('/') : id === 'anotacoes' ? router.navigate('/anotacoes') : router.navigate({ pathname: '/aba/[id]', params: { id } });

  return (<>
    <View style={{ flexDirection: 'row', alignItems: 'center', gap: 12, padding: 14, borderRadius: 16, backgroundColor: alpha(cor, 0.14) }}>
      <Text style={{ fontSize: 34 }}>{a.icon}</Text>
      <Text style={{ color: C.sub, flex: 1, fontSize: 13 }}>{a.desc}</Text>
    </View>
    {!ok && (
      <Card>
        <Text style={{ color: C.text }}>🔒 {t('Esta aba ainda não está no seu plano.')}</Text>
        <BotaoAcao cheio cor={cor} label={'🛒 ' + t('Ver em Compras')} onPress={onCompras} />
      </Card>
    )}

    <Section t={t('Cor da aba')} />
    <Card>
      <Swatches value={cor} onChange={c => setDoc('ajustes', d => ({ ...d, temas: { ...d.temas, [id]: c } }))} />
      <Text style={{ color: C.sub, fontSize: 12 }}>
        {id === 'planner' ? t('Muda só a cor do My Planner. A cor de destaque do app fica em Ajustes > Aparência. Cada tarefa pode ter uma cor própria na ficha.') : t('A cor aparece na barra, nos títulos e nas tarefas ligadas a esta aba.')}
      </Text>
    </Card>

    {id !== 'planner' && ok && <Bloco titulo={t('Avisos desta aba')}><SomDaAba id={id} /></Bloco>}
    {!ABAS_SEM_TRAVA.includes(id) && ok && <SenhaDaAba id={id} />}
    {id !== 'planner' && id !== 'anotacoes' && ok && <CaixinhaDaAba id={id} />}
    {id === 'planner' && <OpcoesPlanner cor={cor} onAvisos={onAvisos} />}
    {id === 'bemestar' && ok && <OpcoesBemEstar cor={cor} />}
    {(MOD_IDS as string[]).includes(id) && temPartes(id as ModId) && (<>
      <Section t={t('Partes desta aba')} />
      <Card><PartesDaAba mod={id as ModId} cor={cor} planner /><Text style={{ color: C.sub, fontSize: 12 }}>{t('O que fica desmarcado some da tela. Os dados continuam guardados.')}</Text></Card>
    </>)}
    {id === 'financas' && ok && <OpcoesFinancas cor={cor} />}
    {id === 'monitor' && ok && (
      <Card>
        <Text style={{ color: C.sub, fontSize: 12 }}>{t('Os perfis, as OABs e os tribunais ficam dentro da aba Publicações. A busca automática roda no servidor às 08h e às 12h (horário de Brasília).')}</Text>
      </Card>
    )}
    {id === 'diario' && ok && (<>
      <Section t={t('Diário')} />
      <ConfigDiario cor={cor} />
    </>)}
    {ABAS_COM_PAGINAS.includes(id) && id !== 'diario' && ok && (<>
      <Section t={t('Páginas desta aba')} />
      <AlvoGuia id={'ajustes.abas.' + id + '.paginas'}><PaginasDaAba aba={id} cor={cor} /></AlvoGuia>
    </>)}
    {!['planner', 'bemestar', 'monitor', 'financas', 'diario', 'estudos', ...ABAS_COM_PAGINAS].includes(id) && ok && (
      <Text style={{ color: C.mute, fontSize: 12 }}>{t('Mais opções desta aba chegam nas próximas versões.')}</Text>
    )}
    {!!onGuia && temComoUsar(id) && <BotaoAcao cor={cor} label={'ⓘ ' + t('Como usar esta aba')} onPress={onGuia} />}
    {ok && <BotaoAcao cor={cor} label={t('Abrir a aba')} onPress={abrir} />}
  </>);
}

/** Alertas dos compromissos (0.67: só o que é das tarefas): quantos alertas estão agendados e os próximos.
 *  O "Testar alerta", o "Abrir configurações" e a explicação sobre bateria e notificações foram para Ajustes > Avisos e alarmes. */
function AlertasDoPlanner({ onAvisos }: { onAvisos: () => void }) {
  const [lista, setLista] = useState<{ titulo: string; quando: Date }[] | null>(null);
  const [total, setTotal] = useState(0);
  useEffect(() => { if (Platform.OS !== 'web') { proximosAlertas(6).then(setLista); totalAgendados().then(setTotal); } }, []);
  const hora = (d: Date) => `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')} ${horaTela(hm(d))}`;
  return (
    <Bloco titulo={t('Alertas dos compromissos')}>
      {Platform.OS !== 'web' && (<>
        <Dica>{t('{n} alerta(s) agendado(s) neste celular para os próximos dias.', { n: total })}</Dica>
        {(lista ?? []).map((a, i) => <Text key={i} style={{ color: C.text, fontSize: 13, paddingBottom: 4 }} numberOfLines={1}>⏰ {hora(a.quando)} · {a.titulo}</Text>)}
        <Divisor />
      </>)}
      <SomDaAba id="planner" />
      <Divisor />
      <Pressable onPress={onAvisos} hitSlop={4} style={{ paddingVertical: 10 }}>
        <Text style={{ color: C.sub, fontSize: 12 }}>{t('Testar alerta, "Não perturbe" e as configurações do celular ficam em Ajustes > Avisos e alarmes.')} <Text style={{ color: C.text, fontWeight: '700' }}>›</Text></Text>
      </Pressable>
    </Bloco>
  );
}

// texto 10 (D): mesmas regras do Diário (Ajustes > Abas > Diário > "Pedir a senha de novo")
const REGRAS_ABA: [RegraSenhaAba, string, string][] = [
  ['sair', N_('Toda vez que sair da aba'), N_('Toda vez que sair')],
  ['5min', N_('Depois de 5 minutos fora'), N_('Depois de 5 min fora')],
  ['app', N_('Só quando o app bloquear'), N_('Quando o app bloquear')],
];

/** "Pedir senha ao abrir esta aba" (texto 10, D). Vem desligado; desligar pede a senha do app. */
function SenhaDaAba({ id }: { id: AbaId }) {
  const aj = useDoc('ajustes');
  const { corDe } = useCores();
  const cor = corDe(id);
  const regra = aj.senhaAba?.[id] ?? null;
  const ident = useConfirmarIdentidade(cor);
  const mudar = async (v: boolean) => {
    if (v) { mudarSenhaAba(id, '5min'); return; }
    if (await ident.pedir(t('Desligar a senha desta aba'))) mudarSenhaAba(id, null);
  };
  return (
    <Bloco titulo={t('Senha desta aba')}>
      <LinhaChave icone="🔒" titulo={t('Pedir senha ao abrir esta aba')} cor={cor} valor={!!regra} onMudar={mudar} />
      {!!regra && (<><Divisor />
        <LinhaOpcoes icone="🔁" titulo={t('Pedir de novo')} valor={regra} rotulo={t(REGRAS_ABA.find(r => r[0] === regra)?.[2] ?? '')}
          opcoes={REGRAS_ABA.map(([k, l]) => [k, t(l)] as [RegraSenhaAba, string])} onEscolher={r => mudarSenhaAba(id, r)} />
      </>)}
      <Dica>{t('O mesmo desbloqueio do app: senha, biometria ou PIN. Pede uma vez ao entrar; dentro da aba não pede de novo. Abrir a galeria, a câmera ou os arquivos não conta como sair. Itens grandes continuam pedindo a senha para excluir.')}</Dica>
      {ident.tela}
    </Bloco>
  );
}

/** 0.65 (Texto 3 C): como a caixinha desta aba aparece no My Planner. 0.67: encolhida (a antecedência das contas foi para Avisos e alarmes). */
function CaixinhaDaAba({ id }: { id: AbaId }) {
  const aj = useDoc('ajustes');
  const modo = modoDaCaixinha(aj.caixinhas, id);
  return (
    <Bloco titulo={t('Caixinha no My Planner')}>
      <LinhaOpcoes icone="📥" titulo={t('Caixinha no My Planner')} valor={modo} opcoes={MODOS_CAIXINHA.map(([m, r]) => [m, t(r)] as [ModoCaixinha, string])}
        onEscolher={m => mudarModoCaixinha(id, m)} />
      <Dica>{t('Resumida: só uma linha com o total. Completa: mostra os itens do dia. Oculta: não aparece. Nada desta aba vira tarefa sozinho.')}
        {id === 'financas' ? ' ' + t('Quantos dias antes as contas aparecem fica em Ajustes > Avisos e alarmes.') : ''}</Dica>
    </Bloco>
  );
}
